import { BaseWidgetService } from './base.widget.service';
import { ListDataService } from './list.data.service';
import { ListModel, QueryParams, paginationType } from '../../models/utilitymodels/list.model';
import { BaseDataModel } from 'common/models/utilitymodels/base.model';
import { SystemService } from './system.service';

export abstract class ListDataWidgetService<T extends BaseDataModel, G extends ListModel<T>> extends BaseWidgetService<T> {
    constructor(public listDataService: ListDataService<T, G>, public systemService: SystemService) {
        super(listDataService, systemService);
    }
    abstract createQueryParams(queryParam: QueryParams): QueryParams;

    modifyParams(params: QueryParams): Promise<QueryParams> {
        return new Promise<QueryParams>((resolve, reject) => {
            resolve(new QueryParams());
        });
    }

    transformListData(res: any) {
        return res;
    }

    getListDataModel(params: any): Promise<T[]> {
        return new Promise((resolve, reject) => {
            Promise.resolve()
                .then(() => {
                    return this.modifyParams(params);
                })
                .then((modifyParams) => {
                    return this.listDataService.getData(modifyParams);
                })
                .then((res) => {
                    resolve(this.transformListData(res));
                })
                .catch((err) => reject(err));
        });
    }

    getListDataModelByApi(params: any): Promise<T[]> {
        return new Promise((resolve, reject) => {
            Promise.resolve()
                .then(() => {
                    return this.listDataService.getData(params);
                })
                .then((res) => {
                    resolve(this.transformListData(res));
                })
                .catch((err) => reject(err));
        });
    }

    processGridData(originalModel: any, queryParam: any): any {
        return this.listDataService.createListModel(originalModel, queryParam);
    }

    getPageData(originalModel: any, recordPerPage: any, pageNumber: any, type: paginationType): any {
        return this.listDataService.getPageData(originalModel, recordPerPage, pageNumber, type);
    }

    filterData(originalModel: any, headers: any, filter: any): any {
        return this.listDataService.filterData(originalModel, headers, filter);
    }

    sortData(originalModel: any, sortFeildHeader: any): any {
        return this.listDataService.sortListData(originalModel, sortFeildHeader);
    }
    // sortDataList(data: any): void {
    //     data.datalist.sort((a, b) => b.id - a.id);
    // }
}
